import { ContractTenant } from '../../common/validations'
import { getTenantName } from './getTenantName'

export const sortGivenTenantFirst = (
  firstTenantName: string,
  tenants: ContractTenant[]
) =>
  tenants.sort((a, b) => {
    if (getTenantName(a) === firstTenantName) return -1
    if (getTenantName(b) === firstTenantName) return +1
    return 0
  })
